
import './reports-branch.scss';
//react
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
//shared
import { BILLING_BRANCH } from '../shared/graphql/branch';
import { TITLE_REPORTS } from './constants/title';
import IFilterBilling from '../shared/interfaces/filters-branch.interface';
import { Titles } from '../shared/components/titles/titles';
import { DATE_MONTH_YEAR } from "./constants/reports-branch";
import { SkeletonTable } from '../shared/components/skeleton-table/skeleton-table';
import { useLocation } from 'react-router-dom';
import { sendPageView } from '../shared/services/analytics';
import { Box, Grid, Switch } from '@mui/material';
import { SelectMui } from '../shared/components/select/select';
import { DataNotFound } from '../shared/components/data-not-found/data-not-found';
import { DATA_NOT_FOUND } from './components/table-read/constants/DataNotFound';

//material

let filters: IFilterBilling;

function Table({ date, branchId, isByYear, selectedMonth, selectedYear  }: { date: any, branchId: number, isByYear: boolean,  selectedMonth: string, selectedYear: number  }) {

    const location = useLocation();

    useEffect(() => {
        sendPageView(location.pathname + location.search, "Reportes");
    }, [location]);

    filters = {
        idBranch: branchId,
        month: String(date.getMonth(date) + 1),
        year: String(date.getFullYear(date)),
        isByYear: isByYear
    };

    const { loading, error, data, refetch } = useQuery(BILLING_BRANCH, {
        variables: filters,
    });

    useEffect(() => {
        refetch({
          idBranch: branchId,
          month: String(getMonthNumberByName(selectedMonth)),
          year: String(selectedYear),
          isByYear: isByYear,
        });
    }, [selectedMonth, selectedYear, isByYear, branchId, refetch]);

    function getMonthNumberByName(month: string) {
        switch (month) {
            case 'enero': return 1;
            case 'febrero': return 2;
            case 'marzo': return 3;
            case 'abril': return 4;
            case 'mayo': return 5;
            case 'junio': return 6;
            case 'julio': return 7;
            case 'agosto': return 8;
            case 'septiembre': return 9;
            case 'octubre': return 10;
            case 'noviembre': return 11;
            case 'diciembre': return 12;
            default: return 1;
        }

    }

    if (loading) return <SkeletonTable></SkeletonTable>;
    if (error) console.log(`Submission error! ${error.message}`);

    let billingReport: any = [];
    let billingReportTotals: any = [];
    let dataBillingReport: any = data.BillingReportByBranch.billing;

    if (dataBillingReport) {
        billingReport = [
            {
                name: 'Cupos atentidos',
                count: (dataBillingReport.feeTook && dataBillingReport.totalTook) ? dataBillingReport.totalTook / dataBillingReport.feeTook : 0,
                value: dataBillingReport?.feeTook,
                total: dataBillingReport?.totalTook,
                class: 'plus-statistics-section'
            },
            {
                name: 'Cancelaciones tardes',
                count: (dataBillingReport.feeLate) ? dataBillingReport.totalLate / dataBillingReport.feeLate : 0,
                value: dataBillingReport?.feeLate,
                total: dataBillingReport?.totalLate,
                class: 'plus-statistics-section'
            },
            {
                name: 'No show',
                count: (dataBillingReport.feeShow) ? dataBillingReport.totalShow / dataBillingReport.feeShow : 0,
                value: dataBillingReport?.feeShow,
                total: dataBillingReport?.totalShow,
                class: 'plus-statistics-section'
            },
            {
                name: 'Clases no dictadas',
                count: (dataBillingReport.feeTook) ? dataBillingReport.total_Teacher / dataBillingReport.feeTook : 0,
                value: dataBillingReport?.feeTook,
                total: dataBillingReport?.total_Teacher,
                class: 'minus-statistics-section'
            },
        ]

        billingReportTotals = [
            {
                name: 'Subtotal',
                subname: '(Sin Iva)',
                total: (dataBillingReport.total - dataBillingReport.iva),
                class: ''
            },
            {
                name: 'IVA',
                subname: null,
                total: dataBillingReport.iva,
                class: ''
            },
            {
                name: 'TOTAL',
                subname: null,
                total: dataBillingReport.total,
                class: 'bg-total'
            }
        ]
    }

    return (
        <div style={{paddingBottom: '2rem'}}>
            {/* <TableRead tableData={data.BillingReportByBranch.billing}></TableRead> */}
            {
                billingReport.map((el: any) => (
                    <Grid container className={el.class}>
                        <Grid item xs={10} className='pcontainer-statistic'>
                            <Box sx={{ display: 'flex' }} className='container-statistic'>
                                <h5>{el.name} ({el.count}) </h5>
                                <span> (Tarifa: ${el.value})</span>
                            </Box>
                        </Grid>
                        <Grid item xs={2} sx={{ textAlign: 'end' }} className='total-statistic'>
                            <h5>${el.total}</h5>
                        </Grid>
                    </Grid>
                ))
            }

            {
                billingReportTotals.map((el: any) => (
                    <Grid container className={`container-statistic-total ${el.class}`}>
                        <Grid item xs={10} className='pcontainer-statistic'>
                            <Box sx={{ display: 'flex' }} >
                                <h5>{el.name}</h5>
                                {el.subname && (<span>&nbsp;{el.subname}</span>)}
                            </Box>
                        </Grid>
                        <Grid item xs={2} sx={{ textAlign: 'end' }} className='total-statistic'>
                            <h5>${el.total}</h5>
                        </Grid>
                    </Grid>
                ))
            }

            {!dataBillingReport && (
                <DataNotFound data={DATA_NOT_FOUND} />
            )}
        </div>
    );
}

export default function ReportsBranch({ branch }: { branch: number }) {
    const title = TITLE_REPORTS;
    let [checkYear, changeYear] = useState(true);
    let [disabledMonthFilter, setDisabledMonthFilter] = useState(true);

    const minDate = new Date(DATE_MONTH_YEAR.minDate);
    const maxDate = new Date(DATE_MONTH_YEAR.maxDate);
    const minYear = minDate.getFullYear();
    const maxYear = maxDate.getFullYear();

    const allowedYears = Array.from({ length: maxYear - minYear + 1 }, (_, index) => {
        const year = minYear + index;
        return { 'id': year, 'name': year };
    });

    const [date, setCount] = useState(new Date());
    let currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 1);
    let previousMonth = currentDate.toLocaleString('default', { month: 'long' });


    const [selectedYear, setSelectedYear] = useState<any>(maxYear);
    const [selectedMonth, setSelectedMonth] = useState<any>(null);


    function getMonthNumberByName(month: string) {
        switch (month) {
            case 'enero': return 1;
            case 'febrero': return 2;
            case 'marzo': return 3;
            case 'abril': return 4;
            case 'mayo': return 5;
            case 'junio': return 6;
            case 'julio': return 7;
            case 'agosto': return 8;
            case 'septiembre': return 9;
            case 'octubre': return 10;
            case 'noviembre': return 11;
            case 'diciembre': return 12;
            default: return 1;
        }

    }

    function getMonthsBetweenDates(minDate: Date, maxDate: Date, selectedYear: number) {
        const months = [];
        let currentDate = new Date(minDate);

        while (currentDate <= maxDate) {
            if (currentDate.getFullYear() === selectedYear) {
                const month = currentDate.toLocaleString('default', { month: 'long' });
                months.push({ 'id': month, 'name': month });
            }

            currentDate.setMonth(currentDate.getMonth() + 1);
        }

        return months;
    }

    const handleYearChange = (year: number) => {
        setSelectedYear(year);

        const newMinDate = new Date(`${year}-01-01`);
        const newMaxDate = new Date(`${year}-12-31`);

        if (new Date().getFullYear() === year) {
            const availableMonths = getMonthsBetweenDates(newMinDate, newMaxDate, year);
            setSelectedMonth(availableMonths.length > 0 ? availableMonths[0].id : '');
        }
    }

    const changeByYear = () => {
        changeYear(checkYear ? false : true);
        setDisabledMonthFilter(disabledMonthFilter ? false : true)

        checkYear ?
            setSelectedMonth(previousMonth) :
            setSelectedMonth(null)
    }

    useEffect(() => {
        const dateFilter = `${getMonthNumberByName(selectedMonth)}-${new Date().getDate()}-${selectedYear}`;

        setCount(new Date(dateFilter));
    }, [selectedMonth, selectedYear]);

    return (
        <div className="section-menu">
            <Titles props={title} />
            {/* <DatePickerMonthYear dateData={DATE_MONTH_YEAR} onAction={(newDate: any) => setCount(newDate)}></DatePickerMonthYear> */}
            <Grid container>
                <Grid item xs={6} className='container-mobile-reports'>
                    <Box sx={{ display: 'flex' }}  className='container-selects container-mobile-reports'>
                        <SelectMui
                            selectData={{
                                value: selectedMonth,
                                items: getMonthsBetweenDates(new Date(DATE_MONTH_YEAR.minDate), new Date(DATE_MONTH_YEAR.maxDate), selectedYear),
                                size: 'large',
                                textLabel: 'Continuar',
                                id: 'month',
                                label: false,
                                disabled: disabledMonthFilter
                            }}
                            onAction={(newValueMonth: any) => setSelectedMonth(newValueMonth)}
                        ></SelectMui>

                        <SelectMui
                            selectData={{
                                // value: String(maxYear),
                                value: selectedYear,
                                items: allowedYears,
                                size: 'large',
                                textLabel: 'Continuar',
                                id: 'year',
                                label: false,
                            }}
                            onAction={(newValueYear: any) => handleYearChange(Number(newValueYear))}
                        ></SelectMui>
                    </Box>
                </Grid>

                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} className='container-switch container-mobile-reports'>
                    <label htmlFor='check-year' className='switch-label'>
                        Todo el año
                    </label>
                    <Switch id='check-year' onClick={() => { changeByYear() }}
                        checked={checkYear} />
                </Grid>

            </Grid>


            <Table date={date} branchId={branch} isByYear={checkYear} selectedMonth={selectedMonth} selectedYear={selectedYear}></Table>
        </div>
    );
}